var a = (e, n, t) => new Promise((d, p) => {
  var c = (i) => {
    try {
      s(t.next(i));
    } catch (o) {
      p(o);
    }
  }, f = (i) => {
    try {
      s(t.throw(i));
    } catch (o) {
      p(o);
    }
  }, s = (i) => i.done ? d(i.value) : Promise.resolve(i.value).then(c, f);
  s((t = t.apply(e, n)).next());
});
import { selfAxios as r } from "@oppein/op-utils";
function g(e) {
  return a(this, null, function* () {
    const {
      data: n
    } = yield r.post(
      "/designapi/design/unified/findCheckTypeList",
      e
    );
    return n;
  });
}
export {
  g as postFindCheckTypeList
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designapi/design/unified/findCheckTypeList/post.js
// module id = 1761
// module chunks = 41